/* ==========================================================================
   Smoosh — Evergreen First-Order PDP interactivity.
   One IIFE, sentinel-guarded. Enhances server-rendered markup:
   - #offer anchor wiring onto the frozen SBR section wrapper
   - smooth-scroll anchors, bubble-burst, sticky-CTA coordination
   - scent library + ingredients modal, UGC carousel + lightbox,
     §3C video walkthrough, sustainability counter, §6 why-accordion,
     athlete video modal.
   prefers-reduced-motion respected for all looping/burst motion.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__evgFirstOrderLoaded) return;
  window.__evgFirstOrderLoaded = true;

  var RM = false;
  try { RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Lightweight modal focus management: focus the close button on open, restore
     focus to the trigger on close, and keep Tab within the dialog. */
  function openModalFocus(modal, trigger) {
    modal._evgReturn = trigger || document.activeElement;
    var focusable = $$('button, a[href], input, video, [tabindex]:not([tabindex="-1"])', modal)
      .filter(function (el) { return el.offsetParent !== null; });
    var first = focusable[0];
    if (first) first.focus();
    modal._evgTrap = function (e) {
      if (e.key !== 'Tab' || !focusable.length) return;
      var f0 = focusable[0], fn = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === f0) { e.preventDefault(); fn.focus(); }
      else if (!e.shiftKey && document.activeElement === fn) { e.preventDefault(); f0.focus(); }
    };
    modal.addEventListener('keydown', modal._evgTrap);
  }
  function closeModalFocus(modal) {
    if (modal._evgTrap) modal.removeEventListener('keydown', modal._evgTrap);
    if (modal._evgReturn && modal._evgReturn.focus) modal._evgReturn.focus();
  }

  /* ── #offer anchor: tag the frozen SBR section wrapper ────────────────── */
  function wireOfferAnchor() {
    if (document.getElementById('offer')) return document.getElementById('offer');
    var sbr = $('.sbr');
    if (!sbr) return null;
    var wrap = sbr.closest('.shopify-section') || sbr.parentElement;
    if (wrap && !document.getElementById('offer')) wrap.id = 'offer';
    return wrap || null;
  }

  /* ── smooth scroll with 72px sticky-nav offset ────────────────────────── */
  function scrollToId(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.scrollY - 72;
    window.scrollTo({ top: y, behavior: RM ? 'auto' : 'smooth' });
  }

  /* ── bubble-burst easter egg ──────────────────────────────────────────── */
  function burst(x, y) {
    if (RM) return;
    var colors = ['#FFCB4E', '#FFD4BF', '#6121EA', '#FEF9F6', '#FFE3D6'];
    var layer = document.createElement('div');
    layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:9999;overflow:hidden;';
    document.body.appendChild(layer);
    for (var i = 0; i < 18; i++) {
      var s = 10 + Math.random() * 22;
      var b = document.createElement('div');
      b.style.cssText = 'position:fixed;border-radius:50%;border:1px solid rgba(255,255,255,0.55);left:' + (x - s / 2) + 'px;top:' + (y - s / 2) + 'px;width:' + s + 'px;height:' + s + 'px;background:' + colors[i % colors.length] + ';';
      layer.appendChild(b);
      var angle = -Math.PI / 2 + (Math.random() - 0.5) * 1.5;
      var dist = 110 + Math.random() * 200;
      var dx = Math.cos(angle) * dist;
      var dy = Math.sin(angle) * dist;
      b.animate([
        { transform: 'translate(0,0) scale(0.4)', opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(1)', opacity: 1, offset: 0.7 },
        { transform: 'translate(' + (dx * 1.1) + 'px,' + (dy * 0.5 + 80) + 'px) scale(0.2)', opacity: 0 }
      ], { duration: 800 + Math.random() * 500, easing: 'cubic-bezier(.2,.6,.2,1)', fill: 'forwards' });
    }
    setTimeout(function () { layer.remove(); }, 1500);
  }
  function burstFrom(el) { var r = el.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2); }

  /* ── generic anchor + burst click delegation ──────────────────────────── */
  function bindGlobalClicks() {
    document.addEventListener('click', function (e) {
      var cartEl = e.target.closest('.evg-nav__cart');
      if (cartEl) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          e.preventDefault();
          drawer.open(cartEl);
          return;
        }
      }
      var scrollEl = e.target.closest('[data-evg-scroll]');
      if (scrollEl) {
        e.preventDefault();
        if (scrollEl.hasAttribute('data-evg-burst')) burstFrom(scrollEl);
        scrollToId(scrollEl.getAttribute('data-evg-scroll'));
        return;
      }
      var burstEl = e.target.closest('[data-evg-burst]');
      if (burstEl) { burstFrom(burstEl); return; }
    });
  }

  /* ── sticky CTA coordination ──────────────────────────────────────────── */
  function initSticky() {
    var sticky = $('[data-evg-sticky]');
    if (!sticky) return;
    var mode = (typeof window !== 'undefined' && window.SMOOSH_PAGE_STICKY) || sticky.getAttribute('data-evg-sticky-mode') || 'auto';
    var heroPassed = false, builderIn = false, islandVisible = false, builderReached = false;
    function upd() {
      var show;
      if (mode === 'off') show = false;
      else if (mode === 'on') show = heroPassed && !builderIn;  // SBR island always wins inside #offer
      // auto: once the builder is reached its own fixed bar takes over the
      // sticky slot permanently, so the page sticky stays hidden (no overlap).
      else show = heroPassed && !builderReached;
      sticky.classList.toggle('is-visible', !!show);
    }
    try {
      window.addEventListener('smoosh:atc-visibility', function (e) {
        islandVisible = !!(e.detail && e.detail.visible);
        if (islandVisible) builderReached = true;
        upd();
      });
    } catch (e) {}
    function observe() {
      var hero = $('[data-evg-hero]') || document.getElementById('hero') || $('.smoosh-hp-hero3');
      if (hero) {
        var ticking = false;
        function evalHero() {
          ticking = false;
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var r = hero.getBoundingClientRect();
          // Sticky appears once the hero is scrolled past a threshold: 1/3 of the
          // hero on desktop (earlier), full clear on mobile.
          var frac = r.height > 0 ? (-r.top / r.height) : 1;
          var threshold = window.innerWidth >= 720 ? 0.33 : 1;
          heroPassed = frac >= threshold;
          // While any part of the hero is on screen, suppress the SBR's own fixed
          // ATC bar (LP-scoped via CSS) so nothing sticky shows over the hero.
          document.documentElement.classList.toggle('evg-hero-in-view', r.bottom > 0 && r.top < vh);
          upd();
        }
        var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(evalHero); } };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        evalHero();
      } else { heroPassed = true; }
      var off = wireOfferAnchor();
      if (off && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          builderIn = es[0].isIntersecting;
          if (builderIn) builderReached = true;
          upd();
        }, { threshold: 0.04 }).observe(off);
      }
      var island = $('[data-atc-island]');
      if (island && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          islandVisible = es[0].isIntersecting;
          if (islandVisible) builderReached = true;
          upd();
        }, { threshold: 0 }).observe(island);
      }
      upd();
    }
    setTimeout(observe, 60);
  }

  /* ── scent library ────────────────────────────────────────────────────── */
  function initScent() {
    var root = $('[data-evg-scent-root]');
    if (!root) return;
    var dataEl = $('[data-evg-scent-data]', root);
    var scents = [];
    try { scents = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!scents.length) return;

    var panel = $('[data-evg-scent-panel]', root);
    var pkg = $('[data-evg-scent-pkg-img]', root);
    var nameL1 = $('[data-evg-scent-name-l1]', root);
    var nameL2 = $('[data-evg-scent-name-l2]', root);
    var desc = $('[data-evg-scent-desc]', root);
    var profile = $('[data-evg-scent-profile-text]', root);
    var profileDot = $('[data-evg-scent-profile-dot]', root);
    var eyebrow = $('[data-evg-scent-eyebrow]', root);

    // Build selector thumbnails from the scent data: a SMOOSH bar silhouette
    // tinted with the accent (darker) on a panel-tint (lighter) halo chip.
    var thumbsWrap = $('[data-evg-scent-thumbs]', root);
    var thumbs = [];
    if (thumbsWrap) {
      scents.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'evg-scent__thumb' + (i === 0 ? ' is-on' : '');
        b.setAttribute('data-evg-scent-pick', i);
        b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        b.setAttribute('aria-label', s.name || ('Scent ' + (i + 1)));
        if (s.name) b.title = s.name;
        b.style.background = s.bg;
        b.style.boxShadow = '0 0 0 2px ' + s.bg + ', 0 0 10px 1px ' + s.bg;
        var span = document.createElement('span');
        span.className = 'evg-scent__thumb-bar';
        span.style.background = s.accent;
        span.setAttribute('aria-hidden', 'true');
        b.appendChild(span);
        b.addEventListener('click', function () { render(i); });
        thumbsWrap.appendChild(b);
        thumbs.push(b);
      });
    }

    // modal
    var modal = $('[data-evg-ingredients-modal]', root);
    var modalName = modal ? $('[data-evg-ingredients-name]', modal) : null;
    var modalBody = modal ? $('[data-evg-ingredients-body]', modal) : null;
    var modalDot = modal ? $('[data-evg-ingredients-dot]', modal) : null;

    function render(i) {
      var s = scents[i]; if (!s) return;
      if (panel) panel.style.background = s.bg;
      if (pkg) { pkg.src = s.pkg; pkg.alt = s.name + ' body wash bars — 2 pack'; }
      var hasSpace = s.name.indexOf(' ') > -1;
      if (nameL1) nameL1.textContent = hasSpace ? s.name.split(' ')[0] : s.name;
      if (nameL2) nameL2.textContent = hasSpace ? s.name.split(' ').slice(1).join(' ') : '\u00A0';
      if (nameL1) nameL1.style.color = s.accent;
      if (nameL2) nameL2.style.color = s.accent;
      if (desc) desc.textContent = s.desc;
      if (profile) profile.textContent = s.profile;
      if (profileDot) profileDot.style.background = s.accent;
      if (eyebrow) eyebrow.style.color = s.accent;
      thumbs.forEach(function (t, ti) {
        var on = ti === i;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      // stash current for modal
      root._evgScentIdx = i;
    }

    function openModal() {
      if (!modal) return;
      var s = scents[root._evgScentIdx || 0];
      if (modalName) modalName.textContent = s.name + ' · Ingredients';
      if (modalName) modalName.style.color = s.accent;
      if (modalDot) modalDot.style.background = s.accent;
      if (modalBody) modalBody.textContent = s.ingredients;
      modal.hidden = false;
      openModalFocus(modal);
    }
    function closeModal() { if (modal && !modal.hidden) { modal.hidden = true; closeModalFocus(modal); } }
    $$('[data-evg-ingredients-open]', root).forEach(function (b) { b.addEventListener('click', function () { openModal(); }); });
    if (modal) {
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-evg-ingredients-close]')) closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    }
    render(0);
  }

  /* ── §3C video walkthrough ────────────────────────────────────────────── */
  function initWalkthrough() {
    var root = $('[data-evg-vw-root]');
    if (!root) return;
    var steps = $$('[data-evg-vw-step]', root);
    var viewport = $('[data-evg-vw-viewport]', root);
    var poster = $('[data-evg-vw-poster]', root);
    var video = $('[data-evg-vw-video]', root);
    var playOverlay = $('.evg-media-slot__play', root);
    var namepill = $('[data-evg-vw-namepill]', root);
    var btn = $('[data-evg-vw-advance]', root);
    var btnLabel = $('[data-evg-vw-label]', root);
    var data = [];
    try { data = JSON.parse($('[data-evg-vw-data]', root).textContent); } catch (e) { return; }
    if (!data.length) return;
    var idx = 0;
    function render() {
      var s = data[idx];
      if (viewport) viewport.style.background = s.bg;
      if (s.video && video) {
        if (video.getAttribute('src') !== s.video) { video.src = s.video; video.load(); }
        video.hidden = false;
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
        if (poster) poster.hidden = true;
        if (playOverlay) playOverlay.style.display = 'none';
      } else {
        if (video) { video.hidden = true; try { video.pause(); } catch (e) {} }
        if (poster) { poster.hidden = false; poster.src = s.poster; poster.alt = s.name; }
        if (playOverlay) playOverlay.style.display = '';
      }
      if (namepill) namepill.textContent = s.name;
      if (btnLabel) btnLabel.textContent = s.cta;
      steps.forEach(function (st, i) { st.classList.toggle('is-active', i === idx); });
    }
    if (btn) btn.addEventListener('click', function () { burstFrom(btn); idx = (idx + 1) % data.length; render(); });
    render();
  }

  /* ── §6 why accordion ─────────────────────────────────────────────────── */
  function initWhyAccordion() {
    var root = $('[data-evg-why-accordion]');
    if (!root) return;
    var feats = $$('[data-evg-why-feat]', root);
    feats.forEach(function (f, i) {
      f.addEventListener('click', function () {
        feats.forEach(function (g, gi) {
          var open = gi === i;
          g.classList.toggle('is-open', open);
          g.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  /* ── §10 sustainability counter ───────────────────────────────────────── */
  function initCounter() {
    var el = $('[data-evg-counter]');
    if (!el) return;
    var rate = parseFloat(el.getAttribute('data-evg-rate')) || 44;
    var start = Date.now();
    function tick() { el.textContent = Math.floor((Date.now() - start) / 1000 * rate).toLocaleString(); }
    tick();
    setInterval(tick, 80);
  }

  /* ── §8B UGC carousel ─────────────────────────────────────────────────── */
  function initUgc() {
    var rail = $('[data-evg-ugc-rail]');
    if (!rail) return;
    var card = $('.evg-ugc__card', rail);
    var stride = card ? (card.offsetWidth + 18) : 318;

    // per-card play / mute toggles — icons are driven by the video's real
    // play/pause/volumechange events so they always match actual media state.
    $$('[data-evg-ugc-play]', rail).forEach(function (btn) {
      var c = btn.closest('.evg-ugc__card');
      var vid = c ? $('video', c) : null;
      function syncPlayIcon() {
        var isPlaying = vid ? (!vid.paused && !vid.ended) : (c.getAttribute('data-playing') === '1');
        if (c) c.setAttribute('data-playing', isPlaying ? '1' : '0');
        $$('[data-evg-ugc-play-icon]', btn).forEach(function (ic) {
          var isPlayIcon = ic.getAttribute('data-evg-ugc-play-icon') === 'play';
          // SVGElement doesn't reflect the .hidden IDL property, so toggle the
          // real attribute (which the [hidden] CSS matches) instead.
          ic.toggleAttribute('hidden', isPlaying ? isPlayIcon : !isPlayIcon);
        });
      }
      btn.addEventListener('click', function () {
        if (!vid) return;
        if (vid.paused) { vid.muted = false; vid.play().catch(function () {}); }
        else { vid.pause(); }
      });
      if (vid) { vid.addEventListener('play', syncPlayIcon); vid.addEventListener('pause', syncPlayIcon); }
      syncPlayIcon();
    });
    $$('[data-evg-ugc-mute]', rail).forEach(function (btn) {
      var c = btn.closest('.evg-ugc__card');
      var vid = c ? $('video', c) : null;
      function syncMuteIcon() {
        var isMuted = vid ? vid.muted : (c.getAttribute('data-muted') !== '0');
        if (c) c.setAttribute('data-muted', isMuted ? '1' : '0');
        $$('[data-evg-ugc-mute-icon]', btn).forEach(function (ic) {
          var isOnIcon = ic.getAttribute('data-evg-ugc-mute-icon') === 'on';
          ic.toggleAttribute('hidden', isMuted ? isOnIcon : !isOnIcon);
        });
      }
      btn.addEventListener('click', function () {
        if (vid) { vid.muted = !vid.muted; }
        else if (c) { c.setAttribute('data-muted', c.getAttribute('data-muted') !== '0' ? '0' : '1'); }
        syncMuteIcon();
      });
      if (vid) vid.addEventListener('volumechange', syncMuteIcon);
      syncMuteIcon();
    });

    // lightbox
    var lightbox = $('[data-evg-ugc-lightbox]');
    $$('[data-evg-ugc-expand]', rail).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!lightbox) return;
        var c = btn.closest('.evg-ugc__card');
        var poster = c.getAttribute('data-poster') || '';
        var label = c.getAttribute('data-label') || '';
        var img = $('[data-evg-ugc-lightbox-img]', lightbox);
        var lab = $('[data-evg-ugc-lightbox-label]', lightbox);
        if (img && poster) img.src = poster;
        if (lab) lab.textContent = label;
        lightbox.hidden = false;
        openModalFocus(lightbox, btn);
      });
    });
    if (lightbox) lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.closest('[data-evg-ugc-lightbox-close]')) { lightbox.hidden = true; closeModalFocus(lightbox); }
    });
    if (lightbox) document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lightbox.hidden) { lightbox.hidden = true; closeModalFocus(lightbox); } });

    // arrows
    var prev = $('[data-evg-ugc-prev]');
    var next = $('[data-evg-ugc-next]');
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -stride, behavior: RM ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: stride, behavior: RM ? 'auto' : 'smooth' }); });

    // endless loop — only if a repeated block exists (rail rendered ×3)
    if (rail.getAttribute('data-evg-ugc-loop') === '1') {
      var unit = rail.scrollWidth / 3;
      rail.scrollLeft = unit;
      var t;
      rail.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          if (rail.scrollLeft <= unit * 0.5) rail.scrollLeft += unit;
          else if (rail.scrollLeft >= unit * 1.5) rail.scrollLeft -= unit;
        }, 130);
      }, { passive: true });
    }
  }

  /* ── athlete video modal ──────────────────────────────────────────────── */
  function initAthleteModal() {
    var open = $('[data-evg-athlete-open]');
    var modal = $('[data-evg-athlete-modal]');
    if (!open || !modal) return;
    function closeAthlete() { if (!modal.hidden) { modal.hidden = true; var v = $('video', modal); if (v) v.pause(); closeModalFocus(modal); } }
    open.addEventListener('click', function () { modal.hidden = false; openModalFocus(modal, open); });
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-evg-athlete-close]')) closeAthlete(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAthlete(); });
  }

  /* ── How-it-works autoplay videos: freeze recovery + play-button fallback ─ */
  /* iOS (esp. Chrome) suspends the decoder when the screen sleeps; on wake the
     clip is frozen yet often still reports paused === false and fires no pause
     event — so we can't rely on paused state. Instead, on return we check
     whether currentTime is actually advancing; if not, hard-reset with load()
     and replay, and surface a tap-to-play button if it still won't run. */
  function initHowVideos() {
    var vids = $$('.evg-how-vid');
    if (!vids.length) return;
    function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () { showBtn(v); }); }
    function showBtn(v) { if (v._evgBtn) v._evgBtn.classList.add('is-on'); }
    function hideBtn(v) { if (v._evgBtn) v._evgBtn.classList.remove('is-on'); }
    function recover(v, userGesture) {
      var t0 = v.currentTime;
      play(v);
      setTimeout(function () {
        if (v.currentTime > t0 + 0.01) { hideBtn(v); return; }   // advancing — fine
        // Frozen/stalled: hard reset the decoder (loops from start, fine for bg clips).
        try { v.load(); } catch (e) {}
        play(v);
        setTimeout(function () {
          if (v.currentTime > 0.01) hideBtn(v);
          else if (!userGesture) showBtn(v);
        }, 600);
      }, 400);
    }
    vids.forEach(function (v) {
      var wrap = v.parentNode;
      if (!wrap) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'evg-how-playbtn';
      btn.setAttribute('aria-label', 'Play video');
      btn.innerHTML = '<svg width="26" height="26" viewBox="0 0 24 24" fill="#140152" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
      btn.addEventListener('click', function () { recover(v, true); });
      wrap.appendChild(btn);
      v._evgBtn = btn;
      v.addEventListener('playing', function () { hideBtn(v); });
      v.addEventListener('pause', function () { showBtn(v); });
      v.addEventListener('error', function () { showBtn(v); });
    });
    function recoverAll() {
      if (document.visibilityState && document.visibilityState !== 'visible') return;
      vids.forEach(function (v) { recover(v, false); });
    }
    document.addEventListener('visibilitychange', recoverAll);
    window.addEventListener('pageshow', recoverAll);
    window.addEventListener('focus', recoverAll);
  }

  function init() {
    wireOfferAnchor();
    bindGlobalClicks();
    initSticky();
    initScent();
    initWalkthrough();
    initWhyAccordion();
    initCounter();
    initUgc();
    initAthleteModal();
    initHowVideos();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
